import React from 'react'
import Item from './item'
import styles from './index.module.less'

interface MoreBooklistProps {
  moreTopList: any
  langConfig: any
  lang: string
  currencyCode: string
}

function MoreBooklist(props: MoreBooklistProps) {
  // console.log(props)

  const { moreTopList, langConfig } = props

  const list = moreTopList.reduce(
    (init, item, index) => {
      // 三个一排， 每排样式不同
      index <= 2 ? init[0].push(item) : init[1].push(item)
      return init
    },
    [[], []]
  )

  return (
    <div className={styles['main']}>
      <div className={styles['head']}>{langConfig.moreBooklist.headTitle}</div>
      <div className={styles['list']}>
        {list.map((arr, index) => {
          const styleMap = index === 0 ? ['yellow', 'blue', 'yellow'] : ['blue', 'yellow', 'blue']

          return arr.map((item, _index) => {
            return <Item key={item.spuId} item={item} index={index} styleType={styleMap[_index]} />
          })
        })}
      </div>
      <div className={styles['block']}></div>
    </div>
  )
}

export default MoreBooklist
